"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ExtractWaitingTelemetry_1 = require("./ExtractWaitingTelemetry");
var ListTelemetry_1 = require("./ListTelemetry");
var PublishingWaitingTelemetry_1 = require("./PublishingWaitingTelemetry");
var SelectProjectTelemetry_1 = require("./SelectProjectTelemetry");
var JumpstartTelemetry = /** @class */ (function () {
    function JumpstartTelemetry(sendEventFn) {
        this.sendEventFn = sendEventFn;
        this.List = new ListTelemetry_1.ListTelemetry(this);
        this.PublishingWaiting = new PublishingWaitingTelemetry_1.PublishingWaitingTelemetry(this);
        this.ExtractWaiting = new ExtractWaitingTelemetry_1.ExtractWaitingTelemetry(this);
        this.SelectProject = new SelectProjectTelemetry_1.SelectProjectTelemetry(this);
    }
    /* tslint:disable-next-line */
    JumpstartTelemetry.prototype.send = function (eventType, eventProperties) {
        if (!eventProperties) {
            this.sendEventFn(eventType, []);
        }
        else {
            this.sendEventFn(eventType, this.convertToNameValuePairList(eventProperties));
        }
    };
    // Prepend jumpstarts to oauth telemetry calls
    /* tslint:disable-next-line */
    JumpstartTelemetry.prototype.sendEventFromOAuth = function (eventType, propertyNameValuePairs) {
        this.sendEventFn('Jumpstart_' + eventType, propertyNameValuePairs);
    };
    /* tslint:disable-next-line:no-any */
    JumpstartTelemetry.prototype.convertToNameValuePairList = function (properties) {
        /* tslint:disable-next-line:no-any */
        var nameValuePairList = [];
        Object.keys(properties).forEach(function (key) {
            nameValuePairList.push(key, properties[key]);
        });
        return nameValuePairList;
    };
    return JumpstartTelemetry;
}());
exports.JumpstartTelemetry = JumpstartTelemetry;
//# sourceMappingURL=JumpstartTelemetry.js.map